export const ShortenUrlDelimiterRegexp = /(?<=<<[^<>\s]*>>)|(?=<<[^<>\s]*>>)/ig
export const ShortenUrlLookupRegexp = /^<<([^<>\s]*)>>$/